import { useState, useEffect } from 'react';
import { useAuth } from '../../../context/AuthContext';
import {
  fetchCustomerBillsWithTracking,
  fetchCustomerPackages,
} from '../services/customerService';

/**
 * Bir müşteriye ait adisyon, tracking ve paket verilerini lazy yükler.
 * enabled=false iken hiçbir şey çekilmez.
 * Memory-safe: useEffect cleanup ile fetch iptal edilir.
 */
export function useCustomerBills(customerId, enabled) {
  const { user } = useAuth();

  const [bills, setBills] = useState([]);
  const [trackingMap, setTrackingMap] = useState({});
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [packagesLoaded, setPackagesLoaded] = useState(false);

  // Adisyon + tracking — expand olduğunda bir kez yükle
  useEffect(() => {
    if (!enabled || !customerId || !user?.businessId || loaded) return;

    let cancelled = false;
    setLoading(true);

    fetchCustomerBillsWithTracking(customerId, user.businessId)
      .then(({ bills: b, trackingMap: tm }) => {
        if (cancelled) return;
        setBills(b);
        setTrackingMap(tm);
        setLoaded(true);
      })
      .catch(() => {
        // best-effort; izin hatası olsa bile UI kırılmaz
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [enabled, customerId, user?.businessId, loaded]);

  // Paketler — expand olduğunda bir kez yükle
  useEffect(() => {
    if (!enabled || !customerId || !user?.businessId || packagesLoaded) return;

    let cancelled = false;

    fetchCustomerPackages(customerId, user.businessId)
      .then((pkgs) => {
        if (!cancelled) {
          setPackages(pkgs);
          setPackagesLoaded(true);
        }
      })
      .catch(() => {
        // best-effort; izin hatası olsa bile UI kırılmaz
      });

    return () => { cancelled = true; };
  }, [enabled, customerId, user?.businessId, packagesLoaded]);

  return { bills, trackingMap, packages, loading };
}
